import React from 'react';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').MediaBlock}
 */
const MediaBlock = ({
    autoplay,
    caption,
    isBreakout,
    media,
}) => {
    return (
        <section className={`${!isBreakout ? 'col-padding' : 'col-wrapper-breakout w-full flex-grow'}`}>
            <figure>
                <Media
                    {
                        ...{
                            ...media,
                            ...(media.image ? {
                                image: {
                                    ...media.image,
                                    containerClassName: 'rounded-lg overflow-hidden pointer-events-none select-none'
                                }
                            } : {} ),
                            ...(media.videoEmbed ? {
                                videoEmbed: {
                                    ...media.videoEmbed,
                                    autoPlay: autoplay,
                                    poster: media?.videoEmbed?.poster || media?.videoEmbed?.embed?.thumbnailUrl
                                }
                            } : {} ),
                            ...(media.video ? {
                                video: {
                                    ...media.video,
                                    autoPlay: autoplay,
                                    showControls: !autoplay,
                                    loop: autoplay,
                                }
                            } : {} )
                        }
                    } />

                {caption && (
                    <figcaption className={`${isBreakout ? 'col-padding': ''} mt-8 type-style-sans-body text-text-default-secondary`}>
                        {caption}
                    </figcaption>
                )}
            </figure>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default MediaBlock;
